import styled from 'styled-components';
import color from 'tinycolor2';
import { Button } from '@pearsontechnology/aero-components';

const getbackgroundColor = (props, defaultColor) => {
  if (props.color) {
    return props.color;
  }
  return defaultColor;
};

export const StyledButton = styled(Button)`
  margin-left: auto;
  color: ${(props) => props.theme['color.orangeDark']};
  &:hover {
    background-color: ${(props) =>
    color(getbackgroundColor(props, props.theme['color.orangeLight']))
      .setAlpha(0.2)
      .toString()} !important ;
  }

  &:focus {
    background-color: ${(props) => props.theme['color.surface']};
    box-shadow: 0 0 0 4px ${(props) => props.theme['color.surface']};
  }
`;
